<template>
  <div>
    <!-- <div>
      <el-button type="primary" @click="addDocumentNew">新增上传任务</el-button>
    </div> -->
    <el-alert title="" type="error">
      <template slot="title">
        <p>1.上传的照片都需要使用彩色扫描件、用扫描王等软件生成照片后上传</p>
        <p>2.所有的文件都需要中英文</p>
        <p>3.学校的文件翻译优先找学校的翻译，如果学校没有英文版需要找有翻译资质的翻译公司盖章。</p>
        <p>4.实习证明的中英文版优先由原公司盖章，如果没有，需要找有翻译资质的翻译公司盖章。</p>
        <p>5.翻译资质：NAATI翻译资质、ITI英国翻译学会。</p>
      </template>
    </el-alert>
    <div v-if="loading == true" >
    <el-skeleton />
    </div >


    <div v-for="(item,index) in list" v-else>
      <el-table
        v-if="item.info.length"
        :data="item.info"
        :span-method="(row, column, rowIndex, columnIndex)=>{return objectSpanMethod({row, column, rowIndex, columnIndex}, item)}"
        :border="true"
        :show-header="objectShowHeader(index)"
        style="width: 100%;">
        <el-table-column
          prop="type"
          label="类型"
          width="150">
          <template>
            <div class="classtype" :style="addclass(item)">
              <div>{{item.name}}</div>
              <div>{{getTitle(item.class)}}</div>
<!--              <div>-->
<!--                <el-button icon="el-icon-circle-plus" size="mini" circle @click="addDocument(item)"></el-button>-->
<!--              </div>-->
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称">
          <template slot-scope="scope">
            {{scope.row.name}}
            <i
              v-if="scope.row.remarks"
              slot="reference"
              class="el-icon-question"
              @click="showRemarks(scope.row)"
            ></i>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.template_id != 61">
              <p v-if="scope.row.material == 1" class="blue-color">已上传</p>
              <p v-if="scope.row.material == 2" class="red-color">未上传</p>
              <p v-if="scope.row.material == 3" class="blue-color">已确认</p>
              <p v-if="scope.row.material == 4" class="red-color" @click="showDetailDialog(scope.row.content)">
                被驳回,查看原因
              </p>
            </div>
            <div v-if="scope.row.template_id == 61">
              <p v-if="scope.row.material == 1 || scope.row.material == 3" class="blue-color">已签字</p>
              <p v-if="scope.row.material == 2" class="red-color">未签字</p>
              <p v-if="scope.row.material == 4" class="red-color" @click="showDetailDialog(scope.row.content)">
                被驳回,查看原因
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="材料(预览/下载)">
          <template slot-scope="scope">
            <div v-if="scope.row.material == 2 || scope.row.template_id == 61"></div>
            <el-link v-else type="primary" @click="()=>{previewUrl=scope.row.upload[0].url;previewName=getFileType(scope.row.templateinfo,scope.row.upload[0].name)}" >
              预览/下载
            </el-link>
          </template>
        </el-table-column>
<!--        <el-table-column label="上传者" width="80">-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.row.material == 2"></div>-->
<!--            <div v-else type="primary" >{{scope.row.upload[0].operator_name }}</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
<!--        <el-table-column label="记录" width="70">-->
<!--          <template slot-scope="scope">-->
<!--            <el-link type="primary" @click="logDocumentInfo(scope.row.upload)">查看</el-link>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column
          width="200"
          prop=""
          label="操作">
          <template slot-scope="scope">
            <div v-if="scope.row.template_id == 61">
              <el-button size="mini"  v-if="scope.row.material == 1 || scope.row.material == 3 || scope.row.material == 4" @click="addSignInfo(scope.row)">
                查看
              </el-button>
              <el-button size="mini" v-else @click="getCheckSignInfo(scope.row.id)">
                签字
              </el-button>
            </div>
            <div v-if="scope.row.template_id != 61">
              <div v-if="scope.row.material != 3">
                <!-- <el-button size="mini" style="margin-left: 15px" @click="logDocumentInfo(scope.row.upload)">记录</el-button> -->
                <el-button size="mini" @click="addDocumentInfo(scope.row)">
                  <span v-if="scope.row.material == 1 || scope.row.material == 4">修改</span>
                  <span v-else>上传</span>
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title="备注"
      :visible.sync="DialogSon"
      width="50%"
      center
      destroy-on-close
    >
      <el-form label-position="top" ref="teacherFrom" size="small" label-width="120px" style="margin: 0">
        <el-form-item>

          <!--          <div v-if="getFileExtension(template_name) == 'png' || getFileExtension(template_name) == 'jpg' || getFileExtension(template_name) == 'jpeg'">-->
          <div class="image-and-remarks" v-if="remarks && template">
            <div style="width: 30%">
              <div style="padding: 0 5px" v-html="remarks"></div>
            </div>
            <div class="in_image">
              <el-image :src="template" :preview-src-list="[template]" class="template_image"></el-image>
            </div>
          </div>
          <div v-if="!remarks && template">
            <div class="one-image">
              <el-image :src="template" :preview-src-list="[template]" class="template_image"></el-image>
            </div>
          </div>
          <div v-if="remarks && !template">
            <div style="width: 100%">
              <div v-html="remarks"></div>
            </div>
          </div>
          <!--          </div>-->
          <!--          <div v-else>-->
          <!--            <span>{{remarks}}</span>-->
          <!--            <el-link type="primary" @click="()=>{previewUrl=template;previewName=template_name}"  v-if="template">-->
          <!--              <span style="margin-left: 1rem;color: rgb(63,158,255);cursor: pointer;">查看/预览</span>-->
          <!--            </el-link>-->
          <!--          </div>-->
          <el-image-viewer
            style="z-index:9999"
            v-if="showViewer"
            :on-close="closeViewer"
            :url-list="[template]"
          />
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button @click="DialogSon = false"  type="info" size="small" style="margin-right: 1rem">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="openDialog" width="50%" center destroy-on-close>
      <div>
        <el-form ref="form" label-width="80px">
          <el-form-item label="类型">
            <el-input v-model="content.type" placeholder="请输入" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="名称">
            <el-input v-model="content.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="content.con" type="textarea" :rows="3" placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDialog = false">取 消</el-button>
        <el-button type="primary" @click="lookScores">保存</el-button>
      </span>
    </el-dialog>


    <HBInfoListDialog :visible.sync="getShowInfoListDialog" :dataSource="infoListDialogDataSource" dialogTitle="详情" @updateVisible="updateDetailVisiable">
      <div v-if="reject_url">
        <span class="hb-info-list-dialog-label">附件： </span>
        <el-link :underline="false" type="primary" @click="()=>{previewUrl=reject_url}">
          预览/下载
        </el-link>
      </div>
    </HBInfoListDialog>

    <!--文书上传弹窗-->
    <show_document ref="showDocument" />
    <!--文书显示弹窗-->
    <upload_document ref="uploadDocument" @show_list="studentProfile" />

    <add_sing_document ref="addSingDocument" @show_list="studentProfile" />

    <HBFilePreview :previewUrl="previewUrl" :fileName="previewName" @updateVisible="previewUrl=null;previewName=null"/>
  </div>
</template>
<script>
import { check_sing_document} from "@/api/mycenter_studyabroad";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { profile_list,user_information_info_add,del_document} from "@/api/mycenter_studyabroad";
import show_document from "./show_document";
import upload_document from "./upload_document";
import add_sing_document from "./add_sing_document";
import HBInfoListDialog from '../HBCommon/HBInfoListDialog/HBInfoListDialog.vue'
import {downloadFile} from '@/api/file'
import HBFilePreview from '@/components/HBCommon/HBFilePreview/HBFilePreview';
export default {
  name: 'TabFour',
  props:["flag"],
  components: {
    ElImageViewer,
    show_document,
    upload_document,
    add_sing_document,
    HBInfoListDialog,
    HBFilePreview
  },
  data() {
    return {
      previewUrl:null,
      previewName:null,
      showViewer: false, // 显示查看器
      DialogSon: false,
      loading:true,
      infoListDialogDataSource:[],
      dialogAddUserSchoolChoice: false,
      openDialog: false,
      list: [],
      reject_url: '',
      content: {
        type_name: '',
        type: '',
        name: '',
        con: '',
        id: ''
      },
      remarks: '',
      template: '',
      template_name: '模板'
    }
  },
  created() {
    this.$bus.on("abroad_tabs_changes",newVal => {
      if (newVal == this.flag) {
        this.studentProfile()
      }
    })
    this.studentProfile()
  },
  methods: {
    getFileType(templateinfo,file) {
      if(templateinfo && templateinfo.alias){
        var str = file.slice(file.lastIndexOf('.') + 1)
        console.log('名称',templateinfo.alias+'.'+str)
        return templateinfo.alias+'.'+str
      }else {
        console.log('名称',file)
        return file
      }
    },
    onPreview() {
      this.showViewer = true
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false
    },
    getTitle(_class){
      if (_class === 'educational_background') {
        return '（教育经历）'
      }
      if (_class === 'exchange_experiences') {
        return '（夏校/交换经历）'
      }
      if (_class === 'academic_projects') {
        return '（学术项目）'
      }
      if (_class === 'work_experience') {
        return '（工作经历）'
      }
      if (_class === 'honorary_rewards') {
        return '（荣誉奖励）'
      }
      if (_class === 'thesis') {
        return '（论文）'
      }
      if (_class === 'extracurricular_activities') {
        return '（课外活动）'
      }
    },
    showRemarks(data) {
      this.DialogSon = true
      this.remarks = data.remarks
      this.template = data.template
      if (data.template) { // 有模板需求的情况下取得名称
        var class_name = ''
        var class_name_info = ''
        if (data.templateinfo) {
          class_name_info = data.templateinfo.name
          var _class = data.templateinfo.class
          if (_class === 'user_base') {
            class_name = '基本信息'
          }
          if (_class === 'educational_background') {
            class_name = '教育经历'
          }
          if (_class === 'language_achievement_and_account_secrecy') {
            class_name = '标化成绩'
          }
          if (_class === 'exchange_experiences') {
            class_name = '夏校/交换经历'
          }
          if (_class === 'academic_projects') {
            class_name = '学术项目'
          }
          if (_class === 'work_experience') {
            class_name = '工作经历'
          }
          if (_class === 'honorary_rewards') {
            class_name = '荣誉奖励'
          }
          if (_class === 'thesis') {
            class_name = '论文'
          }
          if (_class === 'extracurricular_activities') {
            class_name = '课外活动'
          }
        }
        var str = data.template
        var lastIndex = str.lastIndexOf('.')
        var result = str.substr(lastIndex + 1)
        this.template_name = class_name + class_name_info + '模板.' + result
      }
    },
    downLoad(url,name) {
      downloadFile(url,name)
    },
    exportFile(data, fileName, _this){ // url name
      let str = data;
      let lastIndex = str.lastIndexOf('.')
      let result = str.substr(lastIndex+1)
      // 地址不存在时，禁止操作
      if(!data)return;
      // 下载文件并保存到本地
      const callback = (data)=>{
        // 创建a标签，使用 html5 download 属性下载，
        const link = document.createElement('a');
        // 创建url对象
        const objectUrl = window.URL.createObjectURL(new Blob([data]));
        link.style.display='none';
        link.href=objectUrl;
        // 自定义文件名称， fileName
        link.download = fileName+result;
        document.body.appendChild(link);
        link.click();
        // 适当释放url
        window.URL.revokeObjectURL(objectUrl);
      };
      // 把接口返回的url地址转换为 blob
      const xhr = new XMLHttpRequest();
      xhr.open('get', data, true);
      xhr.responseType = 'blob';
      xhr.onload = ()=> {
        // 返回文件流，进行下载处理
        callback(xhr.response);
      };
      xhr.send(); // 不要忘记发送
    },
    updateDetailVisiable(val) {
      if (val == false) {
        this.infoListDialogDataSource = []
      }
    },
    addclass(content) {
      return ""
      // var num = content.info.length * 30
      // return "padding: "+num+"px 0 ;"
    },
    showDetailDialog(item){
      var con = JSON.parse(item)
      this.reject_url = con.url
      this.infoListDialogDataSource = [
        {"label":"驳回原因","content":con.content},
      ]
    },
    objectShowHeader(index) {
      if (index > 0) {
        return false
      } else {
        return true
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }, con) {
      if (row.columnIndex === 0) {
        if (row.rowIndex % con.info.length === 0) {
          return {
            rowspan: con.info.length,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    getCheckSignInfo(_id){
      check_sing_document()
        .then(response => {
          if(response.data == 2){
            this.$message.error("请先完成个人信息、cv、ps、rl必填项；绑定邮箱");
          }else {
            this.addSignInfo(_id)
          }
        })
    },
    addSignInfo(_data){
      if(_data.material == 1 || _data.material == 4|| _data.material == 3){
        this.content.operate = "show";
        this.content.data = _data.upload;
      }else {
        this.content.operate = "add";
        this.content.data = [];
      }
      this.content.type = "sign";
      this.content.id = _data.id;
      this.content.title = "真实性承诺书签名";
      this.$refs.addSingDocument.sendItem(this.content);
    },
    addDocumentInfo(_data) {
      this.content.type = "info";
      this.content.id = _data.id;
      this.content.type_name = _data.name;
      this.content.operate = "add";
      this.content.title = "添加材料";
      this.$refs.uploadDocument.sendItem(this.content);
    },
    logDocumentInfo(content) {
      this.$refs.showDocument.sendItem(content);
    },
    studentProfile() {
      profile_list({ 'user_id': this.$route.query.userId })
        .then(response => {
          this.loading = false
          console.log('获取数据',response.data)
          this.list = response.data
        })
    },
    addDocument(item) {
      this.content.type = item.name
      this.content.id = item.id
      this.openDialog = true
    },
    addDocumentNew() {
      this.content.id = ''
      this.content.type = '额外信息'
      this.openDialog = true
    },
    lookScores() {
      if (!this.content.name) {
        this.$message({
          message: '名称不能为空',
          type: 'warning'
        })
        return
      }
      user_information_info_add({ 'content': this.content, 'user_id': this.$route.query.userId})
        .then(response => {
          this.clearContent()
          this.openDialog = false
          this.studentProfile()
        }).catch(error => {
        this.$message.error(error.message)
      })
    },
    delDocumentInfo(id) {
      del_document({ id: id, type: "info" }).then((response) => {
        this.studentProfile()
      })
    },
    clearContent() {
      this.content.type = ''
      this.content.name = ''
      this.content.con = ''
      this.content.id = ''
      console.log("result:",this.content)
    },

  },
  computed: {
    getShowInfoListDialog: {
      get() {
        if (this.infoListDialogDataSource && this.infoListDialogDataSource.length > 0) {
          return true
        } else {
          return false
        }
      }
    }
  }
}
</script>

<style scoped>

.blue-color{
  color: #08A0EEFF
}
.one-image{
  width: 100%;
  height: 500px;
  overflow: auto;
}
.in_image{
  width: 100%;
  height: 500px;
  overflow: auto;
}
.template_image{
  width: 100%;
}
.image-and-remarks{
  width: 100%;
  height: 500px;
  display: flex;
}
.shuer{
  padding: 10px 0;
  width: 100%;
  background: white;
}
.red-color{
  color: red;
}

/* .classtype span{ margin-bottom: 10px } */
.classtype{
  /* padding: 30px 0 ; */
  /* border:1px solid silver; */
  /* height:100%; */
  /* width: 80%; */
  /* margin: 0 auto; */
  text-align: center;
}
.el-table__row>td{ border: none; }
.el-table::before { height: 0; }
/* .hb-info-list-dialog-label {
  color: darkgrey;
  font-weight: 400;
} */
</style>



// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_four.vue